const data = [
    {
        "content": "Qiu T, Chen N, Zhang S. Robustness Optimization for IoT Topology[M]. Berlin/Heidelberg, Germany: Springer, 2022.",
        "id": 1,
        "language": "英语"
    },
    {
        "content": "Tie Qiu. Linux Application and Developing, Tsinghua University Press, 2016, 368 pages, ISBN: 9787302440321.",
        "id": 2,
        "language": "英语"
    },
    {
        "content": "Tie Qiu, Chen Chen, Yu Zhou. Conference Manual of Linux Kernel API, 2nd Edition, China machine Press, 2011, 640 pages, ISBN: 9787111548775.",
        "id": 3,
        "language": "英语"
    },
    {
        "content": "Tie Qiu, Feng Xia, Yu Zhou. Embedded Wireless Sensor Networks Based on STM32W108, Tsinghua University Press, 2014, 416 pages, ISBN: 9787302346388.",
        "id": 4,
        "language": "英语"
    },
    {
        "content": "Tie Qiu. ARM Embedded System Architecture and Programming, 2nd Edition, Tsinghua University Press, 2013, 378 pages, ISBN: 9787302327479.",
        "id": 5,
        "language": "英语"
    },
    {
        "content": "Tie Qiu, Yu Zhou, Minlei Zhang. Linux-based Qt4 GUI and MySQL Programming, China machine Press, 2012, 488 pages, ISBN: 9787111372912.",
        "id": 6,
        "language": "英语"
    },
    {
        "content": "<strong><u>Qiu T</u></strong>, Chen N, Zhang S. Robustness Optimization for IoT Topology[M]. Berlin/Heidelberg, Germany: <strong>Springer</strong>, 2022.",
        "id": 12,
        "language": "汉语"
    },
    {
        "content": "<strong><u>邱铁</u></strong>&nbsp;编著《<strong>ARM</strong>嵌入式系统结构与编程》第3版，清华大学出版社，2020年12月.&nbsp;ISBN: 9787302557210.&nbsp;备注：该教材被同济大学、华南理工大学、武汉大学、吉林大学、中南大学等60余所高校作为嵌入式教学教材使用。",
        "id": 11,
        "language": "汉语"
    },
    {
        "content": "Lei Wang, <strong><u>Tie Qiu</u></strong>, Wenbing Zhao. Quality, Reliability, Security and Robustness in Heterogeneous Systems. Lecture Notes of the Institute for Computer Sciences, Social Informatics and Telecommunications Engineering, LNICST, volume 234, <strong>Springer</strong>, 2017. ISBN: 9783319780771.",
        "id": 12,
        "language": "汉语"
    },
    {
        "content": "<u>邱铁 </u></strong>编著《Linux操作系统应用与开发教程》， 清华大学出版社，2016年8月出版.&nbsp;ISBN: 9787302440321.",
        "id": 13,
        "language": "汉语"
    },
    {
        "content": "<u>邱铁</u></strong>, 陈晨, 周玉 编著《Linux内核API完全参考手册》第2版，机械工业出版社，2016年10月出版.&nbsp;ISBN: 9787111548775.",
        "id": 14,
        "language": "汉语"
    },
    {
        "content": "<u>邱铁</u></strong>, 夏锋, 周玉《STM32W嵌入式无线传感器网络》， 清华大学出版社，2014年5月出版.&nbsp;ISBN: 9787302346388.",
        "id": 15,
        "language": "汉语"
    },
    {
        "content": "<u>邱铁</u></strong>, 周玉, 张民垒 《Linux环境下Qt4图形界面与MySQL编程》， 机械工业出版社，2012年3月出版.&nbsp;ISBN: 9787111372912.",
        "id": 16,
        "language": "汉语"
    }
];

export default data;
